import { ClubStatus } from "@/constants/club-status.enum";
import { emptyUser } from "@/constants/initial-values.constants";
import { ChangeClubInfoRequest, PadelClub } from "@/models/club.models";
import { GetRequestsPayload, UserFilters } from "@/models/filters.models";
import { ConfirmSignupForm, ForgotPasswordPayload, LoginForm, SignupForm } from "@/models/forms.models";
import { handleError } from "@/services/error-management.service";
import { mapLoginRequest } from "@/services/mapping.service";
import { ActionContext, ActionTree } from "vuex";
import { ActionTypes } from "./action-types";
import { MutationTypes } from "./mutation-types";
import { Mutations } from "./mutations";
import { State } from "./state";
// import { ToastErrors } from '@/constants/generic-errors.enum'
import { ErrorMessages } from "@/constants/error.enum";
// import { useStore } from '@/store/store'
// import router from '@/router';
import { addMembership, adminUserStats, deleteMembership, enableOnlinePayment, getConfigSystemPublic, getUserById, getUsersAxios, nexiSaveConfig, refund, updateDeliverWelcomeKit, updateMembership, updatePhoneNumber, refreshSessionToken } from "@/api/server/anagrafica-index";
import { CreateTournamentRequest, ModifyTournamentRequest } from "@/models/tournaments.models";

/* PER MOCKARE SPECIFICARE "mock" PER USARE IL SERVER SPECIFICARE "server" */
// const apiMode = "server"; //process.env.VUE_APP_IS_MOCK;
import {
  addBooking,
  addNewClub,
  addPlayground,
  banUser,
  changeClubInfo,
  changePlayerCategory,
  changePlaygroundInfo,
  changeProfilePic,
  changeRequestStatus,
  checkBundle,
  clubDetail,
  clubRequests,
  clubSearch,
  confirmBundle,
  confirmSignUp,
  createCard,
  createExceptionRule,
  createPricesRule,
  createTournament,
  deleteCard,
  deleteExceptionRule,
  deletePlayground,
  deletePriceRule,
  deleteTeam,
  deleteTimeslot,
  deleteTournament,
  disableClub,
  duplicatePlayground,
  enableClub,
  forgotPassword,
  forgotPasswordSubmit,
  getCalendarEvents,
  getCard,
  getCards,
  getClubStats,
  getCustomerStats,
  getExceptionRules,
  getMemberships,
  getOpenGames,
  getPlaygroundInfo,
  getPriceRule,
  getPricesRules,
  getTournamentDetails,
  getTournaments,
  getTournamentTeams,
  getUserInfo,
  getUsers,
  modifyBooking,
  modifyTournament,
  myClubs,
  myUserInfo,
  postUserInfo,
  resendSignUp,
  sendOTP,
  signIn,
  signOut,
  signUp,
  subscribeToGame,
  unbanUser,
  unsubscribeToGame,
  updateCard,
  updateExceptionRule,
  updatePriceRule,
  uploadBookingCSV,
  uploadScoreboard,
  verifySmsCode,
  verifyUserAttribute
} from "@/api/server/anagrafica-index";
import { deleteClubPicture, findPaymentsForClub, findUsersClubsForClub, getClubLogo, getClubPictures, getPaymentsWithFilters, getUserClubByUserId, setMainClubPicture, updateClubLogo, updateClubPicture } from "@/api/server/gestioneclub-index";
import { getBookingDetail, subscribeToGameV2, unsubscribeFromGameV2 } from "@/api/server/prenotazioni-index";
import {
  AuthResponseDto,
  CreateMembershipDtoPaymentMethodEnum,
  CreateMembershipDtoStatusEnum,
  FindAllStatusEnum,
  GetCurrentUserInformation200Response,
  Settings,
  // CreateMembershipDtoPaymentMethodEnum,
  // CreateMembershipDtoStatusEnum,
  User
} from "@/generated-sources/anagrafica-api";
import { ClubPicture, PaymentWithBookingDto, UsersClub, UsersClubsResponseDto } from "@/generated-sources/gestioneclub-api";
import { BookingDetailsDto } from "@/generated-sources/prenotazioni-api";
import { client } from "@/api/client-v2";

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(key: K, payload?: Parameters<Mutations[K]>[1]): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, State>, "commit">;

export interface Actions {
  [ActionTypes.LOGIN]({ commit }: AugmentedActionContext, payload: LoginForm): Promise<AuthResponseDto>;
  // [ActionTypes.CURRENT_AUTHENTICATED_USER]({
  //   commit,
  // }: AugmentedActionContext): Promise<any>;
  [ActionTypes.LOGOUT]({ commit }: AugmentedActionContext): Promise<any>;
  [ActionTypes.SIGNUP]({ commit }: AugmentedActionContext, payload: SignupForm): Promise<any>;
  [ActionTypes.CONFIRM_SIGNUP]({ commit }: AugmentedActionContext, payload: ConfirmSignupForm): Promise<any>;
  [ActionTypes.AUTH_ACTION]({ commit }: AugmentedActionContext): Promise<User>;
  // [ActionTypes.CURRENT_SESSION]({
  //   commit,
  // }: AugmentedActionContext): Promise<any>;
  [ActionTypes.RESEND_CODE]({ commit }: AugmentedActionContext, username: string): Promise<any>;
  [ActionTypes.FORGOT_PASSWORD]({ commit }: AugmentedActionContext, username: string): Promise<any>;
  [ActionTypes.FORGOT_PASSWORD_SUBMIT]({ commit }: AugmentedActionContext, payload: ForgotPasswordPayload): Promise<any>;
  // [ActionTypes.COMPLETE_NEW_PASSWORD](
  //   { commit }: AugmentedActionContext,
  //   payload: CompletePasswordPayload
  // ): Promise<any>;
  [ActionTypes.CHECK_TOKEN_VALIDITY]({ commit }: AugmentedActionContext): Promise<{ accessToken: string }>;
  [ActionTypes.GET_CLUB_REQUESTS]({ commit }: AugmentedActionContext, filters: GetRequestsPayload): Promise<any>;
  [ActionTypes.GET_USER_INFO]({ commit }: AugmentedActionContext, mail: string): Promise<any>;
  [ActionTypes.CHANGE_REQUEST_STATUS]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.MY_CLUBS]({ commit }: AugmentedActionContext): Promise<any>;
  [ActionTypes.CHANGE_CLUB_INFO]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.GET_PLAYGROUNDS]({ commit }: AugmentedActionContext, club_id: string): Promise<any>;
  [ActionTypes.PLAYGROUND_DETAIL]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.ADD_PLAYGROUND]({ commit }: AugmentedActionContext, payload: any): Promise<any>;
  [ActionTypes.CHANGE_PLAYGROUND_INFO]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.DELETE_PLAYGROUND]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.CHANGE_PROFILE_PIC]({ commit }: AugmentedActionContext, payload): Promise<any>;
  // [ActionTypes.UPDATE_USER_ATTR](
  [ActionTypes.UPDATE_PHONE_NUMBER]({ commit }: AugmentedActionContext, payload: { id: string; phonenumber: string }): Promise<any>;
  // [ActionTypes.VERIFY_USER_ATTR]({
  [ActionTypes.SEND_SMS_CODE]({
    commit
  }: AugmentedActionContext): // payload
    Promise<any>;
  [ActionTypes.VERIFY_SMS_CODE]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.POST_USER_INFO]({ commit }: AugmentedActionContext, payload: { id: string; user: Partial<User> }): Promise<any>;
  [ActionTypes.ADD_NEW_CLUB]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.GET_CALENDAR_EVENTS]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.GET_USERS]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.GET_USERS_AXIOS]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.FIND_USERSCLUBS_FOR_CLUB]({ commit }: AugmentedActionContext, payload: { clubId: string; filters: UserFilters }): Promise<UsersClubsResponseDto>;
  [ActionTypes.BAN_USER]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.UNBAN_USER]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.GET_CLUB_STATS]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.GET_CUSTOMER_STATS]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.ADD_BOOKING]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.MODIFY_BOOKING]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.GET_CLUBS]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.CLUB_DETAIL]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.DISABLE_CLUB]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.ENABLE_CLUB]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.SEND_OTP]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.DELETE_TIMESLOT]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.CREATE_TOURNAMENT]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.MODIFY_TOURNAMENT]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.DELETE_TOURNAMENT]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.GET_TOURNAMENTS]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.GET_TOURNAMENT_DETAILS]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.GET_TOURNAMENT_TEAMS]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.DELETE_TEAM]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.UPLOAD_SCOREBOARD]({ commit }: AugmentedActionContext, payload): Promise<any>;

  [ActionTypes.GET_PRICES_RULES]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.GET_PRICE_RULE]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.CREATE_PRICE_RULE]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.UPDATE_PRICE_RULE]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.DELETE_PRICE_RULE]({ commit }: AugmentedActionContext, payload): Promise<any>;

  [ActionTypes.GET_EXCEPTION_RULES]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.CREATE_EXCEPTION_RULE]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.UPDATE_EXCEPTION_RULE]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.DELETE_EXCEPTION_RULE]({ commit }: AugmentedActionContext, payload): Promise<any>;

  [ActionTypes.DUPLICATE_PLAYGROUND]({ commit }: AugmentedActionContext, payload: any): Promise<any>;

  [ActionTypes.BOOKING_BUNDLE_CHECK]({ commit }: AugmentedActionContext, payload: any): Promise<any>;
  [ActionTypes.BOOKING_BUNDLE_CONFIRM]({ commit }: AugmentedActionContext, payload: any): Promise<any>;

  [ActionTypes.UPLOAD_BOOKING_CSV]({ commit }: AugmentedActionContext, payload: any): Promise<any>;

  [ActionTypes.GET_CARDS]({ commit }: AugmentedActionContext, payload: any): Promise<any>;
  [ActionTypes.GET_CARD]({ commit }: AugmentedActionContext, payload: any): Promise<any>;
  [ActionTypes.CREATE_CARD]({ commit }: AugmentedActionContext, payload: any): Promise<any>;
  [ActionTypes.UPDATE_CARD]({ commit }: AugmentedActionContext, payload: any): Promise<any>;
  [ActionTypes.DELETE_CARD]({ commit }: AugmentedActionContext, payload: any): Promise<any>;

  [ActionTypes.GET_USER]({ commit }: AugmentedActionContext, payload: any): Promise<any>;
  [ActionTypes.UPDATE_USER_CATEGORY]({ commit }: AugmentedActionContext, payload: any): Promise<any>;

  [ActionTypes.GET_OPEN_GAMES]({ commit }: AugmentedActionContext, payload: any): Promise<any>;
  [ActionTypes.GET_OPEN_GAME]({ commit }: AugmentedActionContext, payload: any): Promise<any>;
  [ActionTypes.GET_BOOKING_DETAIL]({ commit }: AugmentedActionContext, payload: { id: string }): Promise<BookingDetailsDto>;
  [ActionTypes.GET_USERCLUB_DETAIL]({ commit }: AugmentedActionContext, payload: { clubId: string; userId: string }): Promise<UsersClub>;
  [ActionTypes.SUBSCRIBE_TO_GAME]({ commit }: AugmentedActionContext, payload: any): Promise<any>;
  [ActionTypes.SUBSCRIBE_TO_GAME_V2](
    { commit }: AugmentedActionContext,
    payload: {
      booking_id: string;
      wesmash_user_id: string;
      spot: number;
    }
  ): Promise<void>;
  [ActionTypes.UNSUBSCRIBE_TO_GAME]({ commit }: AugmentedActionContext, payload: any): Promise<any>;
  [ActionTypes.UNSUBSCRIBE_FROM_GAME_V2]({ commit }: AugmentedActionContext, payload: { booking_id: string; wesmash_user_id: string }): Promise<void>;

  [ActionTypes.ADMIN_GET_USER_STATS]({ commit }: AugmentedActionContext, payload): Promise<any>;

  [ActionTypes.NEXI_SAVE_CONFIG]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.ENABLE_ONLINE_PAYMENT]({ commit }: AugmentedActionContext, payload): Promise<any>;
  // [ActionTypes.FETCH_TRANSACTIONS](
  //   { commit }: AugmentedActionContext,
  //   payload
  // ): Promise<any>;
  [ActionTypes.FETCH_PAYMENTS_FOR_CLUB]({ commit }: AugmentedActionContext, payload: { clubId: string; date: string }): Promise<PaymentWithBookingDto[]>;
  [ActionTypes.REFUND_TRANSACTION]({ commit }: AugmentedActionContext, payload): Promise<any>;

  [ActionTypes.GET_MEMBERSHIPS]({ commit }: AugmentedActionContext, payload: {
    clubId: string;
    userId: string;
    status: FindAllStatusEnum;
    page?: number;
    limit?: number;
    sortBy?: string;
    sortDirection?: string;
    activationDateFrom?: string;
    activationDateTo?: string;
    expirationDateFrom?: string;
    expirationDateTo?: string;
    descriptionLike?: string;
  }): Promise<any>;

  [ActionTypes.ADD_MEMBERSHIP]({ commit }: AugmentedActionContext, payload): Promise<any>;

  [ActionTypes.UPDATE_MEMBERSHIP]({ commit }: AugmentedActionContext, payload): Promise<any>;

  [ActionTypes.DELETE_MEMBERSHIP]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.DELIVER_WELCOMEKIT]({ commit }: AugmentedActionContext, payload): Promise<any>;
  [ActionTypes.GET_USER_BY_ID]({ commit }: AugmentedActionContext, payload: { userId: string }): Promise<GetCurrentUserInformation200Response>;
  [ActionTypes.GET_CLUB_PICTURES]({ commit }: AugmentedActionContext, payload: { clubId: string }): Promise<ClubPicture[]>;
  [ActionTypes.GET_CLUB_LOGO]({ commit }: AugmentedActionContext, payload: { clubId: string }): Promise<string>;
  [ActionTypes.UPDATE_CLUB_PICTURE]({ commit }: AugmentedActionContext, payload: { clubId: string; isMain: boolean; base64: string }): Promise<void>;
  [ActionTypes.UPDATE_CLUB_LOGO]({ commit }: AugmentedActionContext, payload: { clubId: string; base64: string }): Promise<void>;
  [ActionTypes.DELETE_CLUB_PICTURE]({ commit }: AugmentedActionContext, payload: { clubId: string; pictureId: string }): Promise<void>;
  [ActionTypes.SET_MAIN_CLUB_PICTURE]({ commit }: AugmentedActionContext, payload: { clubId: string; pictureId: string }): Promise<void>;
  [ActionTypes.GET_GLOBAL_SETTINGS]({ commit }: AugmentedActionContext): Promise<Settings>;
}

export const actions: ActionTree<State, State> & Actions = {
  /* ACTION LOGIN */
  async [ActionTypes.LOGIN]({ commit }, payload: LoginForm) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const signInInfo = await client.login({
        username: payload.loginEmail,
        password: payload.loginPassword
      });
      commit(MutationTypes.CLOSE_LOADER);
      return signInInfo;
    } catch (error) {
      handleError(error as Error);
      throw error;
    }
  },

  /* ACTION CURRENT USER INFO */
  // async [ActionTypes.CURRENT_AUTHENTICATED_USER]({ commit }) {
  //   commit(MutationTypes.OPEN_LOADER);
  //   try {
  //     const returnedObj = await currentAuthenticatedUser();
  //     commit(MutationTypes.CLOSE_LOADER);
  //     return returnedObj;
  //   } catch (error) {
  //     handleError(new Error(ErrorMessages.ERROR_REFRESH_TOKENS));
  //     throw error;
  //   }
  // },

  /* ACTION LOGOUT */
  async [ActionTypes.LOGOUT]({ commit }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const returnedObj = await signOut();
      client.logout();
      commit(MutationTypes.SET_USER, emptyUser);
      commit(MutationTypes.CLOSE_LOADER);
      return returnedObj;
    } catch (error) {
      console.log(error);
    }
  },

  /* ACTION SIGNUP */
  async [ActionTypes.SIGNUP]({ commit }, payload: SignupForm) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = mapLoginRequest(payload);
      const returnedObj = await signUp(obj);
      commit(MutationTypes.CLOSE_LOADER);
      return returnedObj;
    } catch (error) {
      handleError(error as Error);
      throw error;
    }
  },

  /* ACTION CONFIRM SIGNUP */
  async [ActionTypes.CONFIRM_SIGNUP]({ commit }, payload: ConfirmSignupForm) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const returnedObj = await confirmSignUp(payload.username, payload.code);
      commit(MutationTypes.CLOSE_LOADER);
      return returnedObj;
    } catch (error) {
      console.log(error);
      handleError(error as Error);
      throw error;
    }
  },

  /* ACTION CURRENT SESSION */
  // TODO WS3: a cosa serve?!?!?!
  // async [ActionTypes.CURRENT_SESSION]({ commit }) {
  //   commit(MutationTypes.OPEN_LOADER);
  //   try {
  //     const _currentSession = await currentSession();
  //     commit(MutationTypes.CLOSE_LOADER);
  //     commit(
  //       MutationTypes.WRITE_TOKENS
  //       // addExpirationToTokens(_currentSession)
  //     );
  //     return _currentSession;
  //   } catch (error) {
  //     //FAI LOGOUT DELL'UTENTE
  //     handleError(new Error(ErrorMessages.ERROR_REFRESH_TOKENS));
  //     throw new Error(ErrorMessages.ERROR_REFRESH_TOKENS);
  //   }
  // },

  /* ACTION CHECK_TOKEN_VALIDITY */
  // Return current tokens (do not refresh here; refresh handled by axios interceptor on 401)
  async [ActionTypes.CHECK_TOKEN_VALIDITY]({ getters }) {
    const tokens = getters.getTokens as AuthResponseDto;
    return {
      idToken: tokens?.idToken || null,
      accessToken: tokens?.accessToken || null,
      refreshToken: (tokens as any)?.refreshToken || null,
    };
  },

  /* ACTION RESEND SIGNUP CODE */
  async [ActionTypes.RESEND_CODE]({ commit }, username: string) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await resendSignUp(username);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error);
      throw error;
    }
  },

  /* ACTION FORGOT PASSWORD */
  async [ActionTypes.FORGOT_PASSWORD]({ commit }, username: string) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await forgotPassword(username);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error);
      throw error;
    }
  },

  /* ACTION FORGOT PASSWORD SUBMIT */
  async [ActionTypes.FORGOT_PASSWORD_SUBMIT]({ commit }, payload: ForgotPasswordPayload) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await forgotPasswordSubmit(payload.username, payload.code, payload.new_password);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error);
      throw error;
    }
  },

  /* ACTION COMPLETE NEW PASSWORD */
  // async [ActionTypes.COMPLETE_NEW_PASSWORD](
  //   { commit },
  //   payload: CompletePasswordPayload
  // ) {
  //   commit(MutationTypes.OPEN_LOADER);
  //   try {
  //     const obj = await completeNewPassword(
  //       payload.user,
  //       payload.newPassword,
  //       payload.requiredAttributes
  //     );
  //     commit(MutationTypes.CLOSE_LOADER);
  //     return obj;
  //   } catch (error) {
  //     handleError(error as Error);
  //     throw error;
  //   }
  // },

  /* ACTION UPDATE USER ATTRIBUTE */
  // async [ActionTypes.UPDATE_USER_ATTR]({ commit }, payload: any) {
  async [ActionTypes.UPDATE_PHONE_NUMBER]({ commit }, payload: { id: string; phonenumber: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      // const obj = await updateUserAttributes(payload.user, payload.attributes);
      const obj = await updatePhoneNumber(payload.id, payload.phonenumber);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION VERIFY USER ATTRIBUTE */
  // async [ActionTypes.VERIFY_USER_ATTR]({ commit }, payload: any) {
  async [ActionTypes.SEND_SMS_CODE]({ commit }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await verifyUserAttribute();
      // payload.user,
      // payload.userAttribute
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION AUTH */
  async [ActionTypes.AUTH_ACTION]({ commit, getters }) {
    // Check if we already have valid user info cached
    const cachedUser = getters.getUser;
    if (cachedUser && cachedUser.id) {
      // User info already loaded, skip API call
      return cachedUser;
    }

    commit(MutationTypes.OPEN_LOADER);
    try {
      const { data } = await client.getUserInfo();
      commit(MutationTypes.CLOSE_LOADER);
      commit(MutationTypes.SET_USER, data.user);
      return data.user;
    } catch (error) {
      commit(MutationTypes.CLOSE_LOADER);

      // Check if this is a 401 error
      const isUnauthorized = error?.response?.status === 401 || error?.status === 401;

      if (isUnauthorized) {
        console.log('[AUTH_ACTION] Token expired, interceptor should handle refresh');
        // Return cached user if available, allowing navigation to proceed
        // The interceptor will refresh tokens on the next API call
        if (cachedUser && cachedUser.id) {
          return cachedUser;
        }
        // If no cached user, return null to trigger login redirect in route guard
        return null;
      }

      // For other errors, handle normally
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET CLUB REQUESTS */
  async [ActionTypes.GET_CLUB_REQUESTS]({ commit }, filters) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await clubRequests(filters);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET USER INFO */
  async [ActionTypes.GET_USER_INFO]({ commit }, id: string) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await getUserInfo(id);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION CHANGE REQUEST STATUS */
  async [ActionTypes.CHANGE_REQUEST_STATUS]({ commit }, payload: { status: string; club_id: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await changeRequestStatus(payload.status, payload.club_id);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION MY CLUBS */
  async [ActionTypes.MY_CLUBS]({ commit }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await client.getMyClubs();
      commit(MutationTypes.CLOSE_LOADER);

      // Handle both paginated and non-paginated responses
      // With Axios interceptor, paginated responses are wrapped in { records: [], pagination: {} }
      // Non-paginated responses remain as arrays
      let clubsData;
      if (obj.data && typeof obj.data === 'object' && 'records' in obj.data && Array.isArray((obj.data as any).records)) {
        // Paginated response - extract records

        // remove type conversion as soon as possible!
        clubsData = (obj.data as any).records as PadelClub[];
      } else if (Array.isArray(obj.data)) {
        // Direct array response
        clubsData = obj.data;
      } else {
        // Fallback to empty array for safety
        console.warn('Unexpected response format for myClubs:', obj.data);
        clubsData = [];
      }

      commit(MutationTypes.WRITE_MY_CLUBS, clubsData);
      return clubsData;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION CHANGE CLUB INFO */
  async [ActionTypes.CHANGE_CLUB_INFO]({ commit }, payload: { club_id: string; request: ChangeClubInfoRequest }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const club = await changeClubInfo(payload.club_id, payload.request);
      commit(MutationTypes.CLOSE_LOADER);
      return club;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET PLAYGROUNDS */
  async [ActionTypes.GET_PLAYGROUNDS]({ commit }, club_id: string) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const playgroundsObj = await client.getPlaygroundsByClubId(club_id);
      //OPERAZIONE PER FILTRARE I CAMPI ELIMINATI

      // Handle axios response structure (migrated from AWS Amplify)
      // Playground data is in playgroundsObj.data.records (paginated response)
      const playgrounds = playgroundsObj?.data?.playgrounds || [];

      const filteredArray = Array.isArray(playgrounds)
        ? playgrounds.filter(el => !el.status || el.status !== ClubStatus.DELETED)
        : [];

      await commit(MutationTypes.WRITE_MY_PLAYGROUNDS, filteredArray);
      commit(MutationTypes.CLOSE_LOADER);
      return filteredArray;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION PLAYGROUND DETAIL */
  async [ActionTypes.PLAYGROUND_DETAIL](
    { commit },
    payload: {
      club_id: string;
      playground_id: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const club = await getPlaygroundInfo(payload.club_id, payload.playground_id);
      commit(MutationTypes.CLOSE_LOADER);
      return club;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION ADD PLAYGROUND */
  async [ActionTypes.ADD_PLAYGROUND](
    { commit },
    payload: {
      club_id: string;
      request: any;
      handleLoaderInternally: boolean;
    }
  ) {
    if (payload.handleLoaderInternally) {
      commit(MutationTypes.OPEN_LOADER);
    }
    try {
      const club = await addPlayground(payload.club_id, payload.request);
      if (payload.handleLoaderInternally) {
        commit(MutationTypes.CLOSE_LOADER);
      }
      return club;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION CHANGE PLAYGROUND INFO */
  async [ActionTypes.CHANGE_PLAYGROUND_INFO](
    { commit },
    payload: {
      club_id: string;
      playground_id: string;
      request: any;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const club = await changePlaygroundInfo(payload.club_id, payload.playground_id, payload.request);
      commit(MutationTypes.CLOSE_LOADER);
      return club;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION DELETE PLAYGROUND */
  async [ActionTypes.DELETE_PLAYGROUND](
    { commit },
    payload: {
      club_id: string;
      playground_id: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await deletePlayground(payload.club_id, payload.playground_id);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION CHANGE PROFILE PICTURE */
  async [ActionTypes.CHANGE_PROFILE_PIC]({ commit }, picture: string) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const urlPic = await changeProfilePic(picture);
      commit(MutationTypes.CLOSE_LOADER);
      return urlPic;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION CHANGE PROFILE PICTURE */
  async [ActionTypes.VERIFY_SMS_CODE]({ commit }, _code: string) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const urlPic = await verifySmsCode(_code);
      commit(MutationTypes.CLOSE_LOADER);
      return urlPic;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION POST USER INFO */
  async [ActionTypes.POST_USER_INFO]({ commit }, payload: { id: string; user: User }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await postUserInfo(payload.id, payload.user);
      commit(MutationTypes.SET_USER, obj);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION ADD NEW CLUB */
  async [ActionTypes.ADD_NEW_CLUB](
    { commit },
    payload: {
      club: any;
      // token: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await addNewClub(payload);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET CALENDAR EVENTS */
  async [ActionTypes.GET_CALENDAR_EVENTS](
    { commit },
    payload: {
      club_id: string;
      date?: string;
      user_id?: string;
      future?: boolean;
      archived?: boolean;
      deleted?: boolean;
      hideLoader?: boolean;
    }
  ) {
    if (!payload.hideLoader) {
      commit(MutationTypes.OPEN_LOADER);
    }
    try {
      const obj = await getCalendarEvents(payload);
      if (!payload.hideLoader) {
        commit(MutationTypes.CLOSE_LOADER);
      }

      // Handle axios response structure (migrated from AWS Amplify)
      // Calendar events come as direct array in obj.data
      const eventsData = obj.data || [];

      return eventsData;
    } catch (error) {
      handleError(error as Error, true);
      if (!payload.hideLoader) {
        commit(MutationTypes.CLOSE_LOADER);
      }
      throw error;
    }
  },

  /* ACTION GET USERS */
  async [ActionTypes.GET_USERS](
    { commit },
    payload: {
      club_id: string;
      filters: UserFilters;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await getUsers(payload.club_id, payload.filters);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  async [ActionTypes.GET_USERS_AXIOS](
    { commit },
    payload: {
      club_id: string;
      filters: UserFilters;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await getUsersAxios(payload.club_id, payload.filters);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION BAN USER */
  async [ActionTypes.BAN_USER](
    { commit },
    payload: {
      club_id: string;
      user_id: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await banUser(payload.club_id, payload.user_id);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION UNBAN USER */
  async [ActionTypes.UNBAN_USER](
    { commit },
    payload: {
      club_id: string;
      user_id: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await unbanUser(payload.club_id, payload.user_id);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET CLUB STATISTICS */
  async [ActionTypes.GET_CLUB_STATS](
    { commit },
    payload: {
      club_id: string;
      start_date: string;
      handleLoaderInternally: boolean;
    }
  ) {
    if (payload.handleLoaderInternally) {
      commit(MutationTypes.OPEN_LOADER);
    }
    try {
      const obj = await getClubStats(payload.club_id, payload.start_date);
      if (payload.handleLoaderInternally) {
        commit(MutationTypes.CLOSE_LOADER);
      }

      // Handle axios response structure (migrated from AWS Amplify)
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  async [ActionTypes.GET_CUSTOMER_STATS](
    { commit },
    payload: {
      club_id: string;
      start_date: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await getCustomerStats(payload.club_id, payload.start_date);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle axios response structure (migrated from AWS Amplify)
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION ADD BOOKING */
  async [ActionTypes.ADD_BOOKING]({ commit }, booking) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await addBooking(booking);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle axios response structure (migrated from AWS Amplify)
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION MODIFY BOOKING */
  async [ActionTypes.MODIFY_BOOKING]({ commit }, booking) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await modifyBooking(booking);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle axios response structure (migrated from AWS Amplify)
      return obj.data;
    } catch (error) {
      console.log(error)
      handleError(error as Error, false);
      throw error;
    }
  },

  /* ACTION GET CLUBS */
  async [ActionTypes.GET_CLUBS]({ commit }, nameFilter: string) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await clubSearch(nameFilter);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle both paginated and non-paginated responses
      // With Axios interceptor, paginated responses are wrapped in { records: [], pagination: {} }
      // Non-paginated responses remain as { clubs: [] }
      const clubsData = obj.data?.records ? obj.data.records : obj.data.clubs;

      return clubsData;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION CLUB DETAIL */
  async [ActionTypes.CLUB_DETAIL]({ commit }, club_id: string) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await clubDetail(club_id);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle axios response structure (migrated from AWS Amplify)
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION DISABLE CLUB */
  async [ActionTypes.DISABLE_CLUB]({ commit }, club_id: string) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await disableClub(club_id);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle axios response structure (migrated from AWS Amplify)
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION ENABLE CLUB */
  async [ActionTypes.ENABLE_CLUB]({ commit }, club_id: string) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await enableClub(club_id);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle axios response structure (migrated from AWS Amplify)
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION SEND OTP */
  async [ActionTypes.SEND_OTP]({ commit }, phone_number: string) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await sendOTP(phone_number);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle both paginated and non-paginated responses
      // With Axios interceptor, paginated responses are wrapped in { records: [], pagination: {} }
      // Non-paginated responses remain as { otp: "..." }
      const otpData = obj.data?.records ? obj.data.records : obj.data.otp;

      return otpData;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION DELETE TIMESLOT */
  async [ActionTypes.DELETE_TIMESLOT]({ commit }, booking) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await deleteTimeslot(booking);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle axios response structure (migrated from AWS Amplify)
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION CREATE_TOURNAMENT */
  async [ActionTypes.CREATE_TOURNAMENT](
    { commit },
    payload: {
      club_id: string;
      tournament: CreateTournamentRequest;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await createTournament(payload.club_id, payload.tournament);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle axios response structure (migrated from AWS Amplify)
      return obj.data;
    } catch (error) {
      handleError(error as Error, false);
      throw error;
    }
  },

  /* ACTION MODIFY_TOURNAMENT */
  async [ActionTypes.MODIFY_TOURNAMENT](
    { commit },
    payload: {
      club_id: string;
      tournament_id: string;
      tournament: ModifyTournamentRequest;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await modifyTournament(payload.club_id, payload.tournament_id, payload.tournament);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle axios response structure (migrated from AWS Amplify)
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION DELETE_TOURNAMENT */
  async [ActionTypes.DELETE_TOURNAMENT](
    { commit },
    payload: {
      club_id: string;
      tournament_id: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await deleteTournament(payload.club_id, payload.tournament_id);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle axios response structure (migrated from AWS Amplify)
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET_TOURNAMENTS */
  async [ActionTypes.GET_TOURNAMENTS]({ commit }, club_id: string) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await getTournaments(club_id);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle both paginated and non-paginated responses
      // With Axios interceptor, paginated responses are wrapped in { records: [], pagination: {} }
      // Non-paginated responses remain as { tournaments: [] }
      const tournamentsData = obj.data?.records ? obj.data.records : obj.data.tournaments;

      return tournamentsData;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET_TOURNAMENTS_DETAILS */
  async [ActionTypes.GET_TOURNAMENT_DETAILS](
    { commit },
    payload: {
      club_id: string;
      tournament_id: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await getTournamentDetails(payload.club_id, payload.tournament_id);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle axios response structure (migrated from AWS Amplify)
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET_TOURNAMENT_TEAMS */
  async [ActionTypes.GET_TOURNAMENT_TEAMS](
    { commit },
    payload: {
      club_id: string;
      tournament_id: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await getTournamentTeams(payload.club_id, payload.tournament_id);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle both paginated and non-paginated responses
      // With Axios interceptor, paginated responses are wrapped in { records: [], pagination: {} }
      // Non-paginated responses remain as { teams: [] }
      const teamsData = obj.data?.records ? obj.data.records : obj.data.teams;

      return teamsData;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION DELETE_TEAM */
  async [ActionTypes.DELETE_TEAM](
    { commit },
    payload: {
      club_id: string;
      tournament_id: string;
      booker_id: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await deleteTeam(payload.club_id, payload.tournament_id, payload.booker_id);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle axios response structure (migrated from AWS Amplify)
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION UPLOAD_SCOREBOARD */
  async [ActionTypes.UPLOAD_SCOREBOARD](
    { commit },
    payload: {
      club_id: string;
      tournament_id: string;
      file: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await uploadScoreboard(payload.club_id, payload.tournament_id, { scoreboard: payload.file });
      commit(MutationTypes.CLOSE_LOADER);

      // Handle axios response structure (migrated from AWS Amplify)
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET_PRICES_RULES */
  async [ActionTypes.GET_PRICES_RULES]({ commit }, payload: object) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await getPricesRules(payload);
      commit(MutationTypes.CLOSE_LOADER);

      // Debug: let's see what structure we're getting for prices rules
      console.log('GET_PRICES_RULES response:', obj);
      console.log('GET_PRICES_RULES response.data:', obj?.data);

      // Handle axios response structure (migrated from AWS Amplify)
      // Component expects full pagination object, not just records
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET_PRICE_RULE */
  async [ActionTypes.GET_PRICE_RULE]({ commit }, payload: { id: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await getPriceRule(payload.id);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle axios response structure (migrated from AWS Amplify)
      // Single price rule should return data directly
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION CREATE_PRICE_RULE */
  async [ActionTypes.CREATE_PRICE_RULE]({ commit }, payload: object) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await createPricesRule(payload);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      // TODO : Check on 409
      commit(MutationTypes.CLOSE_LOADER);
      // handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION UPDATE_PRICE_RULE */
  async [ActionTypes.UPDATE_PRICE_RULE]({ commit }, payload: { id: string; body: object }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await updatePriceRule(payload);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      // TODO : Check on 409
      commit(MutationTypes.CLOSE_LOADER);
      // handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION DELETE_PRICE_RULE */
  async [ActionTypes.DELETE_PRICE_RULE]({ commit }, payload: { id: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await deletePriceRule(payload.id);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      // TODO : Check on 409
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET_EXCEPTION_RULES */
  async [ActionTypes.GET_EXCEPTION_RULES]({ commit }, payload: object) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await getExceptionRules(payload);
      commit(MutationTypes.CLOSE_LOADER);

      // Handle axios response structure (migrated from AWS Amplify)
      // Component expects full pagination object, not just records
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION CREATE_EXCEPTION_RULE */
  async [ActionTypes.CREATE_EXCEPTION_RULE]({ commit }, payload: object) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await createExceptionRule(payload);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      // TODO : Check on 409
      commit(MutationTypes.CLOSE_LOADER);
      // handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION UPDATE_EXCEPTION_RULE */
  async [ActionTypes.UPDATE_EXCEPTION_RULE]({ commit }, payload: { id: string; body: object }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await updateExceptionRule(payload);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      // TODO : Check on 409
      commit(MutationTypes.CLOSE_LOADER);
      // handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION DELETE_EXCEPTION_RULE */
  async [ActionTypes.DELETE_EXCEPTION_RULE]({ commit }, payload: { id: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await deleteExceptionRule(payload.id);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      // TODO : Check on 409
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION DUPLICATE_PLAYGROUND */
  async [ActionTypes.DUPLICATE_PLAYGROUND](
    { commit },
    payload: {
      club_id: string;
      id: string;
      name: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const club = await duplicatePlayground(payload.club_id, payload.id, payload.name);
      commit(MutationTypes.CLOSE_LOADER);
      return club;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION BOOKING_BUNDLE_CHECK */
  async [ActionTypes.BOOKING_BUNDLE_CHECK]({ commit }, payload: object[]) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await checkBundle(payload);
      commit(MutationTypes.CLOSE_LOADER);
      return response.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION BOOKING_BUNDLE_CONFIRM */
  async [ActionTypes.BOOKING_BUNDLE_CONFIRM]({ commit }, payload: object[]) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await confirmBundle(payload);
      commit(MutationTypes.CLOSE_LOADER);
      return response.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION UPLOAD_BOOKING_CSV */
  async [ActionTypes.UPLOAD_BOOKING_CSV]({ commit }, payload: { club_id: string; id: string; file: File }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await uploadBookingCSV(payload.club_id, payload.id, payload.file);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET_CARDS */
  async [ActionTypes.GET_CARDS]({ commit }, payload: { user_id: string; limit: number; club_id?: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await getCards(payload.user_id, payload.limit, payload.club_id);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET_CARD */
  async [ActionTypes.GET_CARD]({ commit }, payload: { card_id: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await getCard(payload.card_id);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION CREATE_CARD */
  async [ActionTypes.CREATE_CARD]({ commit }, payload: object) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await createCard(payload);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION UPDATE_CARD */
  async [ActionTypes.UPDATE_CARD]({ commit }, payload: object) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await updateCard(payload);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION DELETE_CARD */
  async [ActionTypes.DELETE_CARD]({ commit }, payload: object) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await deleteCard(payload);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET_USER */
  async [ActionTypes.GET_USER]({ commit }, payload: { club_id: string; user_id: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await client.getUser({ userId: payload.user_id });
      commit(MutationTypes.CLOSE_LOADER);
      return response.data.user;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION UPDATE_USER_CATEGORY */
  async [ActionTypes.UPDATE_USER_CATEGORY]({ commit }, payload: { club_id: string; user_id: string; category: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await changePlayerCategory(payload.club_id, payload.user_id, payload.category);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET_OPEN_GAMES */
  async [ActionTypes.GET_OPEN_GAMES]({ commit }, payload: { club_id: string; match_type?: string; status?: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await getOpenGames(payload.club_id, payload.match_type, payload.status);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET_OPEN_GAME */
  async [ActionTypes.GET_OPEN_GAME]({ commit }, payload: { id: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await getBookingDetail(payload.id);
      commit(MutationTypes.CLOSE_LOADER);
      return response.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },
  async [ActionTypes.GET_BOOKING_DETAIL]({ commit }, payload: { id: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await getBookingDetail(payload.id);
      commit(MutationTypes.CLOSE_LOADER);
      return response.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },
  async [ActionTypes.GET_USERCLUB_DETAIL]({ commit }, payload: { clubId: string; userId: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await getUserClubByUserId(payload.clubId, payload.userId);
      commit(MutationTypes.CLOSE_LOADER);
      return response.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION SUBSCRIBE_TO_GAME */
  async [ActionTypes.SUBSCRIBE_TO_GAME](
    { commit },
    payload: {
      booking_id: string;
      wesmash_user_id: string;
      spot: number;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await subscribeToGame(payload.booking_id, payload.wesmash_user_id, payload.spot);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },
  async [ActionTypes.SUBSCRIBE_TO_GAME_V2](
    { commit },
    payload: {
      booking_id: string;
      wesmash_user_id: string;
      spot: number;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await subscribeToGameV2(payload.booking_id, payload.wesmash_user_id, payload.spot);
      commit(MutationTypes.CLOSE_LOADER);
      return response.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION UNSUBSCRIBE_TO_GAME */
  async [ActionTypes.UNSUBSCRIBE_TO_GAME]({ commit }, payload: { booking_id: string; wesmash_user_id: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await unsubscribeToGame(payload.booking_id, payload.wesmash_user_id);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },
  async [ActionTypes.UNSUBSCRIBE_FROM_GAME_V2]({ commit }, payload: { booking_id: string; wesmash_user_id: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await unsubscribeFromGameV2(payload.booking_id, payload.wesmash_user_id);
      commit(MutationTypes.CLOSE_LOADER);
      return response.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  async [ActionTypes.ADMIN_GET_USER_STATS]({ commit }, payload: { month: string; year: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await adminUserStats(payload.month, payload.year);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* NEXI */
  async [ActionTypes.NEXI_SAVE_CONFIG]({ commit }, payload: { club_id: string; mac: string; alias: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await nexiSaveConfig(payload.club_id, payload.mac, payload.alias);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  async [ActionTypes.ENABLE_ONLINE_PAYMENT]({ commit }, payload: { club_id: string; enable: boolean }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await enableOnlinePayment(payload.club_id, payload.enable);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  // async [ActionTypes.FETCH_TRANSACTIONS](
  //   { commit },
  //   payload: { club_id: string; refund: boolean; date: string }
  // ) {
  //   commit(MutationTypes.OPEN_LOADER);
  //   try {
  //     const response = await fetchTransactions(
  //       payload.club_id,
  //       payload.refund,
  //       payload.date
  //     );
  //     commit(MutationTypes.CLOSE_LOADER);
  //     return response;
  //   } catch (error) {
  //     handleError(error as Error, true);
  //     throw error;
  //   }
  // },
  async [ActionTypes.FETCH_PAYMENTS_FOR_CLUB](
    { commit },
    payload: {
      clubId: string;
      date: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await findPaymentsForClub(payload.clubId, payload.date);
      commit(MutationTypes.CLOSE_LOADER);

      // This API returns PaymentWithBookingDto[] directly, not paginated
      const paymentsData = obj.data;

      return paymentsData;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  async [ActionTypes.REFUND_TRANSACTION](
    { commit },
    payload: {
      club_id: string;
      bookingId: string;
      refundPercentage: number;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const response = await refund(payload.club_id, payload.bookingId, payload.refundPercentage);
      commit(MutationTypes.CLOSE_LOADER);
      return response;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION GET MEMBERSHIPS */
  async [ActionTypes.GET_MEMBERSHIPS](
    { commit },
    payload: {
      clubId: string;
      userId: string;
      status: FindAllStatusEnum;
      page?: number;
      limit?: number;
      sortBy?: string;
      sortDirection?: string;
      activationDateFrom?: string;
      activationDateTo?: string;
      expirationDateFrom?: string;
      expirationDateTo?: string;
      descriptionLike?: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await getMemberships(
        payload.clubId,
        payload.userId,
        payload.status,
        payload.page,
        payload.limit,
        payload.sortBy,
        payload.sortDirection,
        payload.activationDateFrom,
        payload.activationDateTo,
        payload.expirationDateFrom,
        payload.expirationDateTo,
        payload.descriptionLike
      );
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION ADD MEMBERSHIP */
  async [ActionTypes.ADD_MEMBERSHIP](
    { commit },
    payload: {
      clubId: string;
      userId: string;
      price: number;
      description: string;
      autoRenewal: boolean;
      paymentMethod: CreateMembershipDtoPaymentMethodEnum;
      status: CreateMembershipDtoStatusEnum;
      activationDate: string;
      expirationDate: string;
      notes: string;
      renewalDate: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await addMembership(payload);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION UPDATE MEMBERSHIP */
  async [ActionTypes.UPDATE_MEMBERSHIP](
    { commit },
    payload: {
      id: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await updateMembership(payload.id, {});
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION DELETE MEMBERSHIP */
  async [ActionTypes.DELETE_MEMBERSHIP](
    { commit },
    payload: {
      id: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await deleteMembership(payload.id);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },

  /* ACTION UPDATE DELIVER_WELCOMEKIT */
  async [ActionTypes.DELIVER_WELCOMEKIT](
    { commit },
    payload: {
      id: string;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await updateDeliverWelcomeKit(payload.id);
      commit(MutationTypes.CLOSE_LOADER);
      return obj;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },
  async [ActionTypes.GET_USER_BY_ID]({ commit }, payload: { userId: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      //
      const ret = await getUserById(payload.userId);
      // const mappedInfo = mapUserInfo(_userInfo);
      commit(MutationTypes.CLOSE_LOADER);
      return ret.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },
  async [ActionTypes.GET_CLUB_PICTURES]({ commit }, payload: { clubId: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      //
      const ret = await getClubPictures(payload.clubId);
      // const mappedInfo = mapUserInfo(_userInfo);
      commit(MutationTypes.CLOSE_LOADER);
      return ret.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },
  async [ActionTypes.GET_CLUB_LOGO]({ commit }, payload: { clubId: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      //
      const ret = await getClubLogo(payload.clubId);
      // const mappedInfo = mapUserInfo(_userInfo);
      commit(MutationTypes.CLOSE_LOADER);

      // This API returns GetClubLogoResponse with pictureLink property
      const logoData = ret.data.pictureLink;

      return logoData;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },
  async [ActionTypes.FIND_USERSCLUBS_FOR_CLUB](
    { commit },
    payload: {
      clubId: string;
      filters: UserFilters;
    }
  ) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      const obj = await findUsersClubsForClub(payload.clubId, payload.filters);
      commit(MutationTypes.CLOSE_LOADER);
      return obj.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },
  async [ActionTypes.UPDATE_CLUB_PICTURE]({ commit }, payload: { clubId: string; base64: string; isMain: boolean }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      //
      await updateClubPicture(payload.clubId, payload.base64, payload.isMain);
      // const mappedInfo = mapUserInfo(_userInfo);
      commit(MutationTypes.CLOSE_LOADER);
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },
  async [ActionTypes.UPDATE_CLUB_LOGO]({ commit }, payload: { clubId: string; base64: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      //
      await updateClubLogo(payload.clubId, payload.base64);
      // const mappedInfo = mapUserInfo(_userInfo);
      commit(MutationTypes.CLOSE_LOADER);
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },
  async [ActionTypes.DELETE_CLUB_PICTURE]({ commit }, payload: { clubId: string; pictureId: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      //
      await deleteClubPicture(payload.clubId, payload.pictureId);
      // const mappedInfo = mapUserInfo(_userInfo);
      commit(MutationTypes.CLOSE_LOADER);
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },
  async [ActionTypes.SET_MAIN_CLUB_PICTURE]({ commit }, payload: { clubId: string; pictureId: string }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      //
      await setMainClubPicture(payload.clubId, payload.pictureId);
      // const mappedInfo = mapUserInfo(_userInfo);
      commit(MutationTypes.CLOSE_LOADER);
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  },
  async [ActionTypes.GET_GLOBAL_SETTINGS]({ commit }) {
    commit(MutationTypes.OPEN_LOADER);
    try {
      //
      const ret = await getConfigSystemPublic();
      // const mappedInfo = mapUserInfo(_userInfo);
      commit(MutationTypes.CLOSE_LOADER);
      return ret.data;
    } catch (error) {
      handleError(error as Error, true);
      throw error;
    }
  }
};
